var render = function () {
  var _vm$value, _vm$value$gift, _vm$value$gift$phone, _vm$value$gift$phone$, _vm$value2, _vm$value2$gift, _vm$value2$gift$amoun, _vm$value2$gift$amoun2, _vm$value3, _vm$value3$gift, _vm$value3$gift$count, _vm$value3$gift$count2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "480"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("default", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', {
    staticClass: "v-card--dialog"
  }, [_c('div', {
    staticClass: "v-card--dialog__head"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("선물하기 발송내역")]), _c('v-btn', {
    staticClass: "v-card--dialog__close",
    attrs: {
      "fab": "",
      "color": "transparent"
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-divider'), _c('div', {
    staticClass: "v-card--dialog__body page-text"
  }, [_c('v-sheet', {
    staticClass: "mx-auto px-3 py-12",
    attrs: {
      "max-width": "240"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    staticClass: "font-weight-bold",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" 연락처 ")]), _c('v-col', {
    staticClass: "text-end",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" " + _vm._s(((_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : (_vm$value$gift = _vm$value.gift) === null || _vm$value$gift === void 0 ? void 0 : (_vm$value$gift$phone = _vm$value$gift.phone) === null || _vm$value$gift$phone === void 0 ? void 0 : (_vm$value$gift$phone$ = _vm$value$gift$phone.phoneNumberFormat) === null || _vm$value$gift$phone$ === void 0 ? void 0 : _vm$value$gift$phone$.call(_vm$value$gift$phone)) || "-") + " ")]), _c('v-col', {
    staticClass: "font-weight-bold",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" 보내는 금액 ")]), _c('v-col', {
    staticClass: "text-end",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" " + _vm._s(((_vm$value2 = _vm.value) === null || _vm$value2 === void 0 ? void 0 : (_vm$value2$gift = _vm$value2.gift) === null || _vm$value2$gift === void 0 ? void 0 : (_vm$value2$gift$amoun = _vm$value2$gift.amount) === null || _vm$value2$gift$amoun === void 0 ? void 0 : (_vm$value2$gift$amoun2 = _vm$value2$gift$amoun.format) === null || _vm$value2$gift$amoun2 === void 0 ? void 0 : _vm$value2$gift$amoun2.call(_vm$value2$gift$amoun)) || 0) + " 원 ")]), _c('v-col', {
    staticClass: "font-weight-bold",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" 발송회수 ")]), _c('v-col', {
    staticClass: "text-end",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" " + _vm._s(((_vm$value3 = _vm.value) === null || _vm$value3 === void 0 ? void 0 : (_vm$value3$gift = _vm$value3.gift) === null || _vm$value3$gift === void 0 ? void 0 : (_vm$value3$gift$count = _vm$value3$gift.count) === null || _vm$value3$gift$count === void 0 ? void 0 : (_vm$value3$gift$count2 = _vm$value3$gift$count.format) === null || _vm$value3$gift$count2 === void 0 ? void 0 : _vm$value3$gift$count2.call(_vm$value3$gift$count)) || 0) + " 회 ")]), _c('v-col', {
    staticClass: "font-weight-bold",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" 상태 ")]), _c('v-col', {
    staticClass: "text-end",
    attrs: {
      "cols": "7"
    }
  }, [_vm._v(" " + _vm._s(_vm.value.type) + " ")])], 1)], 1)], 1), !_vm.disabled ? _c('div', {
    staticClass: "v-card--dialog__foot"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "end"
    }
  }, [_c('v-col', [_c('v-row', {
    staticClass: "row--small primary--text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" * ")]), _c('v-col', {
    staticClass: "page-text page-text--small"
  }, [_vm._v(" 발송가능 횟수는 총 3회입니다. ")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', _vm._b({
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('redo');
      }
    }
  }, 'v-btn', {
    loading: _vm.loading,
    disabled: _vm.disabled_redo
  }, false), [_c('span', [_vm._v("재발송")])])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', _vm._b({
    attrs: {
      "color": "error"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('undo');
      }
    }
  }, 'v-btn', {
    loading: _vm.loading,
    disabled: _vm.disabled
  }, false), [_c('span', [_vm._v("취소")])])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }